<template>
  <v-navigation-drawer
    persistent
    :clipped="true"
    v-model="drawer"
    enable-resize-watcher
    fixed
    app
    v-if="$route.name != 'Login'"
  >
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <i class="material-icons">account_circle</i>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{$store.getters['user/fullName']}} ({{$store.getters['user/instanceName']}})</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>

      <template v-for="item in $store.getters['interfaceSettings/filteredMenu']">

        <v-list-tile v-if="item.children.length == 0" :to="item.link" :key="item.title">
          <v-list-tile-action>
            <v-icon>{{item.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title v-text="item.title"></v-list-tile-title>
        </v-list-tile>

        <v-list-group v-else :prepend-icon="item.icon" no-action :key="item.title">
          <v-list-tile slot="activator">
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-for="(subitem, i) in item.children" :key="i" :to="subitem.link">
            <v-list-tile-title v-text="subitem.title"></v-list-tile-title>
          </v-list-tile>
        </v-list-group>
      </template>
      <v-list-tile @click.stop="$store.dispatch('user/logout')">
        <v-list-tile-action>
          <v-icon>power_settings_new</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>{{$t('menu.logout')}}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  name: "NavigationDrawer",
  data() {
    return {};
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    }
  },
  computed: {
    drawer: {
      get() {
        return this.$store.state.interfaceSettings.navigationDrawer;
      },
      set(newValue) {
        this.$store.commit("interfaceSettings/SET_navigationDrawer", newValue);
      }
    }
  }
};
</script>
<style>
.v-list__tile--active {
  background-color: #e4e4e4 !important;
  font-weight: bold !important;
}
</style>
